module.exports = __webpack_public_path__ + "static/media/15-g8.8abeb717.jpg";